import { AppDispatch } from "src/store";
import {
  getAllBriefData,
  getCompetitorsAsync,
  getQuestions,
  getSerpCompetitors
} from "./thunks";
import { CompetitorType } from "./types";

export const getBaseKeyword = (keyword: string) => {
  if (!keyword || keyword.length <= 2 || !keyword.includes(" ")) {
    return keyword;
  }
  const splitedKeyword = keyword.split(" ");
  const lastWord = splitedKeyword[splitedKeyword.length - 1];
  const lastChar = lastWord.slice(-1);
  if (["s", "es", "ed", "ing", "ies"].includes(lastChar)) {
    return [
      ...splitedKeyword.slice(0, splitedKeyword.length - 1),
      lastWord.slice(0, -1),
    ].join(" ");
  }
  return keyword;
};

export const changeSourceToLink = (outlines: any[] = []) => {
  const newOutlines = outlines?.map((outline) => {
    if (!outline.urls) {
      outline.urls = [];
    }

    if (outline.source) {
      outline.urls.push(outline.source);
    }
    return { ...outline, source: undefined };
  });
  return newOutlines;
};
export const locations = [
  {
    location_name: "Afghanistan",
    country_iso_code: "AF",
  },
  {
    location_name: "Albania",
    country_iso_code: "AL",
  },
  {
    location_name: "Antarctica",
    country_iso_code: "AQ",
  },
  {
    location_name: "Algeria",
    country_iso_code: "DZ",
  },
  {
    location_name: "American Samoa",
    country_iso_code: "AS",
  },
  {
    location_name: "Andorra",
    country_iso_code: "AD",
  },
  {
    location_name: "Angola",
    country_iso_code: "AO",
  },
  {
    location_name: "Antigua and Barbuda",
    country_iso_code: "AG",
  },
  {
    location_name: "Azerbaijan",
    country_iso_code: "AZ",
  },
  {
    location_name: "Argentina",
    country_iso_code: "AR",
  },
  {
    location_name: "Australia",
    country_iso_code: "AU",
  },
  {
    location_name: "Austria",
    country_iso_code: "AT",
  },
  {
    location_name: "The Bahamas",
    country_iso_code: "BS",
  },
  {
    location_name: "Bahrain",
    country_iso_code: "BH",
  },
  {
    location_name: "Bangladesh",
    country_iso_code: "BD",
  },
  {
    location_name: "Armenia",
    country_iso_code: "AM",
  },
  {
    location_name: "Barbados",
    country_iso_code: "BB",
  },
  {
    location_name: "Belgium",
    country_iso_code: "BE",
  },
  {
    location_name: "Bhutan",
    country_iso_code: "BT",
  },
  {
    location_name: "Bolivia",
    country_iso_code: "BO",
  },
  {
    location_name: "Bosnia and Herzegovina",
    country_iso_code: "BA",
  },
  {
    location_name: "Botswana",
    country_iso_code: "BW",
  },
  {
    location_name: "Brazil",
    country_iso_code: "BR",
  },
  {
    location_name: "Belize",
    country_iso_code: "BZ",
  },
  {
    location_name: "Solomon Islands",
    country_iso_code: "SB",
  },
  {
    location_name: "Brunei",
    country_iso_code: "BN",
  },
  {
    location_name: "Bulgaria",
    country_iso_code: "BG",
  },
  {
    location_name: "Myanmar (Burma)",
    country_iso_code: "MM",
  },
  {
    location_name: "Burundi",
    country_iso_code: "BI",
  },
  {
    location_name: "Cambodia",
    country_iso_code: "KH",
  },
  {
    location_name: "Cameroon",
    country_iso_code: "CM",
  },
  {
    location_name: "Canada",
    country_iso_code: "CA",
  },
  {
    location_name: "Cape Verde",
    country_iso_code: "CV",
  },
  {
    location_name: "Central African Republic",
    country_iso_code: "CF",
  },
  {
    location_name: "Sri Lanka",
    country_iso_code: "LK",
  },
  {
    location_name: "Chad",
    country_iso_code: "TD",
  },
  {
    location_name: "Chile",
    country_iso_code: "CL",
  },
  {
    location_name: "China",
    country_iso_code: "CN",
  },
  {
    location_name: "Christmas Island",
    country_iso_code: "CX",
  },
  {
    location_name: "Cocos (Keeling) Islands",
    country_iso_code: "CC",
  },
  {
    location_name: "Colombia",
    country_iso_code: "CO",
  },
  {
    location_name: "Comoros",
    country_iso_code: "KM",
  },
  {
    location_name: "Republic of the Congo",
    country_iso_code: "CG",
  },
  {
    location_name: "Democratic Republic of the Congo",
    country_iso_code: "CD",
  },
  {
    location_name: "Cook Islands",
    country_iso_code: "CK",
  },
  {
    location_name: "Costa Rica",
    country_iso_code: "CR",
  },
  {
    location_name: "Croatia",
    country_iso_code: "HR",
  },
  {
    location_name: "Cyprus",
    country_iso_code: "CY",
  },
  {
    location_name: "Czechia",
    country_iso_code: "CZ",
  },
  {
    location_name: "Benin",
    country_iso_code: "BJ",
  },
  {
    location_name: "Denmark",
    country_iso_code: "DK",
  },
  {
    location_name: "Dominica",
    country_iso_code: "DM",
  },
  {
    location_name: "Dominican Republic",
    country_iso_code: "DO",
  },
  {
    location_name: "Ecuador",
    country_iso_code: "EC",
  },
  {
    location_name: "El Salvador",
    country_iso_code: "SV",
  },
  {
    location_name: "Equatorial Guinea",
    country_iso_code: "GQ",
  },
  {
    location_name: "Ethiopia",
    country_iso_code: "ET",
  },
  {
    location_name: "Eritrea",
    country_iso_code: "ER",
  },
  {
    location_name: "Estonia",
    country_iso_code: "EE",
  },
  {
    location_name: "South Georgia and the South Sandwich Islands",
    country_iso_code: "GS",
  },
  {
    location_name: "Fiji",
    country_iso_code: "FJ",
  },
  {
    location_name: "Finland",
    country_iso_code: "FI",
  },
  {
    location_name: "France",
    country_iso_code: "FR",
  },
  {
    location_name: "French Polynesia",
    country_iso_code: "PF",
  },
  {
    location_name: "French Southern and Antarctic Lands",
    country_iso_code: "TF",
  },
  {
    location_name: "Djibouti",
    country_iso_code: "DJ",
  },
  {
    location_name: "Gabon",
    country_iso_code: "GA",
  },
  {
    location_name: "Georgia",
    country_iso_code: "GE",
  },
  {
    location_name: "The Gambia",
    country_iso_code: "GM",
  },
  {
    location_name: "Germany",
    country_iso_code: "DE",
  },
  {
    location_name: "Ghana",
    country_iso_code: "GH",
  },
  {
    location_name: "Kiribati",
    country_iso_code: "KI",
  },
  {
    location_name: "Greece",
    country_iso_code: "GR",
  },
  {
    location_name: "Grenada",
    country_iso_code: "GD",
  },
  {
    location_name: "Guam",
    country_iso_code: "GU",
  },
  {
    location_name: "Guatemala",
    country_iso_code: "GT",
  },
  {
    location_name: "Guinea",
    country_iso_code: "GN",
  },
  {
    location_name: "Guyana",
    country_iso_code: "GY",
  },
  {
    location_name: "Haiti",
    country_iso_code: "HT",
  },
  {
    location_name: "Heard Island and McDonald Islands",
    country_iso_code: "HM",
  },
  {
    location_name: "Vatican City",
    country_iso_code: "VA",
  },
  {
    location_name: "Honduras",
    country_iso_code: "HN",
  },
  {
    location_name: "Hungary",
    country_iso_code: "HU",
  },
  {
    location_name: "Iceland",
    country_iso_code: "IS",
  },
  {
    location_name: "India",
    country_iso_code: "IN",
  },
  {
    location_name: "Indonesia",
    country_iso_code: "ID",
  },
  {
    location_name: "Iraq",
    country_iso_code: "IQ",
  },
  {
    location_name: "Ireland",
    country_iso_code: "IE",
  },
  {
    location_name: "Israel",
    country_iso_code: "IL",
  },
  {
    location_name: "Italy",
    country_iso_code: "IT",
  },
  {
    location_name: "Cote d'Ivoire",
    country_iso_code: "CI",
  },
  {
    location_name: "Jamaica",
    country_iso_code: "JM",
  },
  {
    location_name: "Japan",
    country_iso_code: "JP",
  },
  {
    location_name: "Kazakhstan",
    country_iso_code: "KZ",
  },
  {
    location_name: "Jordan",
    country_iso_code: "JO",
  },
  {
    location_name: "Kenya",
    country_iso_code: "KE",
  },
  {
    location_name: "South Korea",
    country_iso_code: "KR",
  },
  {
    location_name: "Kuwait",
    country_iso_code: "KW",
  },
  {
    location_name: "Kyrgyzstan",
    country_iso_code: "KG",
  },
  {
    location_name: "Laos",
    country_iso_code: "LA",
  },
  {
    location_name: "Lebanon",
    country_iso_code: "LB",
  },
  {
    location_name: "Lesotho",
    country_iso_code: "LS",
  },
  {
    location_name: "Latvia",
    country_iso_code: "LV",
  },
  {
    location_name: "Liberia",
    country_iso_code: "LR",
  },
  {
    location_name: "Libya",
    country_iso_code: "LY",
  },
  {
    location_name: "Liechtenstein",
    country_iso_code: "LI",
  },
  {
    location_name: "Lithuania",
    country_iso_code: "LT",
  },
  {
    location_name: "Luxembourg",
    country_iso_code: "LU",
  },
  {
    location_name: "Madagascar",
    country_iso_code: "MG",
  },
  {
    location_name: "Malawi",
    country_iso_code: "MW",
  },
  {
    location_name: "Malaysia",
    country_iso_code: "MY",
  },
  {
    location_name: "Maldives",
    country_iso_code: "MV",
  },
  {
    location_name: "Mali",
    country_iso_code: "ML",
  },
  {
    location_name: "Malta",
    country_iso_code: "MT",
  },
  {
    location_name: "Mauritania",
    country_iso_code: "MR",
  },
  {
    location_name: "Mauritius",
    country_iso_code: "MU",
  },
  {
    location_name: "Mexico",
    country_iso_code: "MX",
  },
  {
    location_name: "Monaco",
    country_iso_code: "MC",
  },
  {
    location_name: "Mongolia",
    country_iso_code: "MN",
  },
  {
    location_name: "Moldova",
    country_iso_code: "MD",
  },
  {
    location_name: "Montenegro",
    country_iso_code: "ME",
  },
  {
    location_name: "Morocco",
    country_iso_code: "MA",
  },
  {
    location_name: "Mozambique",
    country_iso_code: "MZ",
  },
  {
    location_name: "Oman",
    country_iso_code: "OM",
  },
  {
    location_name: "Namibia",
    country_iso_code: "NA",
  },
  {
    location_name: "Nauru",
    country_iso_code: "NR",
  },
  {
    location_name: "Nepal",
    country_iso_code: "NP",
  },
  {
    location_name: "Netherlands",
    country_iso_code: "NL",
  },
  {
    location_name: "Curacao",
    country_iso_code: "CW",
  },
  {
    location_name: "Sint Maarten",
    country_iso_code: "SX",
  },
  {
    location_name: "Caribbean Netherlands",
    country_iso_code: "BQ",
  },
  {
    location_name: "New Caledonia",
    country_iso_code: "NC",
  },
  {
    location_name: "Vanuatu",
    country_iso_code: "VU",
  },
  {
    location_name: "New Zealand",
    country_iso_code: "NZ",
  },
  {
    location_name: "Nicaragua",
    country_iso_code: "NI",
  },
  {
    location_name: "Niger",
    country_iso_code: "NE",
  },
  {
    location_name: "Nigeria",
    country_iso_code: "NG",
  },
  {
    location_name: "Niue",
    country_iso_code: "NU",
  },
  {
    location_name: "Norfolk Island",
    country_iso_code: "NF",
  },
  {
    location_name: "Norway",
    country_iso_code: "NO",
  },
  {
    location_name: "Northern Mariana Islands",
    country_iso_code: "MP",
  },
  {
    location_name: "United States Minor Outlying Islands",
    country_iso_code: "UM",
  },
  {
    location_name: "Federated States of Micronesia",
    country_iso_code: "FM",
  },
  {
    location_name: "Marshall Islands",
    country_iso_code: "MH",
  },
  {
    location_name: "Palau",
    country_iso_code: "PW",
  },
  {
    location_name: "Pakistan",
    country_iso_code: "PK",
  },
  {
    location_name: "Panama",
    country_iso_code: "PA",
  },
  {
    location_name: "Papua New Guinea",
    country_iso_code: "PG",
  },
  {
    location_name: "Paraguay",
    country_iso_code: "PY",
  },
  {
    location_name: "Peru",
    country_iso_code: "PE",
  },
  {
    location_name: "Philippines",
    country_iso_code: "PH",
  },
  {
    location_name: "Pitcairn Islands",
    country_iso_code: "PN",
  },
  {
    location_name: "Poland",
    country_iso_code: "PL",
  },
  {
    location_name: "Portugal",
    country_iso_code: "PT",
  },
  {
    location_name: "Guinea-Bissau",
    country_iso_code: "GW",
  },
  {
    location_name: "Timor-Leste",
    country_iso_code: "TL",
  },
  {
    location_name: "Qatar",
    country_iso_code: "QA",
  },
  {
    location_name: "Romania",
    country_iso_code: "RO",
  },
  {
    location_name: "Rwanda",
    country_iso_code: "RW",
  },
  {
    location_name: "Saint Barthelemy",
    country_iso_code: "BL",
  },
  {
    location_name: "Saint Helena, Ascension and Tristan da Cunha",
    country_iso_code: "SH",
  },
  {
    location_name: "Saint Kitts and Nevis",
    country_iso_code: "KN",
  },
  {
    location_name: "Saint Lucia",
    country_iso_code: "LC",
  },
  {
    location_name: "Saint Martin",
    country_iso_code: "MF",
  },
  {
    location_name: "Saint Pierre and Miquelon",
    country_iso_code: "PM",
  },
  {
    location_name: "Saint Vincent and the Grenadines",
    country_iso_code: "VC",
  },
  {
    location_name: "San Marino",
    country_iso_code: "SM",
  },
  {
    location_name: "Sao Tome and Principe",
    country_iso_code: "ST",
  },
  {
    location_name: "Saudi Arabia",
    country_iso_code: "SA",
  },
  {
    location_name: "Senegal",
    country_iso_code: "SN",
  },
  {
    location_name: "Serbia",
    country_iso_code: "RS",
  },
  {
    location_name: "Seychelles",
    country_iso_code: "SC",
  },
  {
    location_name: "Sierra Leone",
    country_iso_code: "SL",
  },
  {
    location_name: "Singapore",
    country_iso_code: "SG",
  },
  {
    location_name: "Slovakia",
    country_iso_code: "SK",
  },
  {
    location_name: "Vietnam",
    country_iso_code: "VN",
  },
  {
    location_name: "Slovenia",
    country_iso_code: "SI",
  },
  {
    location_name: "Somalia",
    country_iso_code: "SO",
  },
  {
    location_name: "South Africa",
    country_iso_code: "ZA",
  },
  {
    location_name: "Zimbabwe",
    country_iso_code: "ZW",
  },
  {
    location_name: "Spain",
    country_iso_code: "ES",
  },
  {
    location_name: "South Sudan",
    country_iso_code: "SS",
  },
  {
    location_name: "Sudan",
    country_iso_code: "SD",
  },
  {
    location_name: "Suriname",
    country_iso_code: "SR",
  },
  {
    location_name: "Eswatini",
    country_iso_code: "SZ",
  },
  {
    location_name: "Sweden",
    country_iso_code: "SE",
  },
  {
    location_name: "Switzerland",
    country_iso_code: "CH",
  },
  {
    location_name: "Tajikistan",
    country_iso_code: "TJ",
  },
  {
    location_name: "Thailand",
    country_iso_code: "TH",
  },
  {
    location_name: "Togo",
    country_iso_code: "TG",
  },
  {
    location_name: "Tokelau",
    country_iso_code: "TK",
  },
  {
    location_name: "Tonga",
    country_iso_code: "TO",
  },
  {
    location_name: "Trinidad and Tobago",
    country_iso_code: "TT",
  },
  {
    location_name: "United Arab Emirates",
    country_iso_code: "AE",
  },
  {
    location_name: "Tunisia",
    country_iso_code: "TN",
  },
  {
    location_name: "Turkey",
    country_iso_code: "TR",
  },
  {
    location_name: "Turkmenistan",
    country_iso_code: "TM",
  },
  {
    location_name: "Tuvalu",
    country_iso_code: "TV",
  },
  {
    location_name: "Uganda",
    country_iso_code: "UG",
  },
  {
    location_name: "Ukraine",
    country_iso_code: "UA",
  },
  {
    location_name: "North Macedonia",
    country_iso_code: "MK",
  },
  {
    location_name: "Egypt",
    country_iso_code: "EG",
  },
  {
    location_name: "United Kingdom",
    country_iso_code: "GB",
  },
  {
    location_name: "Guernsey",
    country_iso_code: "GG",
  },
  {
    location_name: "Jersey",
    country_iso_code: "JE",
  },
  {
    location_name: "Tanzania",
    country_iso_code: "TZ",
  },
  {
    location_name: "United States",
    country_iso_code: "US",
  },
  {
    location_name: "Burkina Faso",
    country_iso_code: "BF",
  },
  {
    location_name: "Uruguay",
    country_iso_code: "UY",
  },
  {
    location_name: "Uzbekistan",
    country_iso_code: "UZ",
  },
  {
    location_name: "Venezuela",
    country_iso_code: "VE",
  },
  {
    location_name: "Wallis and Futuna",
    country_iso_code: "WF",
  },
  {
    location_name: "Samoa",
    country_iso_code: "WS",
  },
  {
    location_name: "Yemen",
    country_iso_code: "YE",
  },
  {
    location_name: "Zambia",
    country_iso_code: "ZM",
  },
];

export const usStates = [
  { state_name: "Alabama", location_name: "Alabama,United States", state_code: "AL" },
  { state_name: "Alaska", location_name: "Alaska,United States", state_code: "AK" },
  { state_name: "Arizona", location_name: "Arizona,United States", state_code: "AZ" },
  { state_name: "Arkansas", location_name: "Arkansas,United States", state_code: "AR" },
  { state_name: "California", location_name: "California,United States", state_code: "CA" },
  { state_name: "Colorado", location_name: "Colorado,United States", state_code: "CO" },
  { state_name: "Connecticut", location_name: "Connecticut,United States", state_code: "CT" },
  { state_name: "Delaware", location_name: "Delaware,United States", state_code: "DE" },
  { state_name: "Florida", location_name: "Florida,United States", state_code: "FL" },
  { state_name: "Georgia", location_name: "Georgia,United States", state_code: "GA" },
  { state_name: "Hawaii", location_name: "Hawaii,United States", state_code: "HI" },
  { state_name: "Idaho", location_name: "Idaho,United States", state_code: "ID" },
  { state_name: "Illinois", location_name: "Illinois,United States", state_code: "IL" },
  { state_name: "Indiana", location_name: "Indiana,United States", state_code: "IN" },
  { state_name: "Iowa", location_name: "Iowa,United States", state_code: "IA" },
  { state_name: "Kansas", location_name: "Kansas,United States", state_code: "KS" },
  { state_name: "Kentucky", location_name: "Kentucky,United States", state_code: "KY" },
  { state_name: "Louisiana", location_name: "Louisiana,United States", state_code: "LA" },
  { state_name: "Maine", location_name: "Maine,United States", state_code: "ME" },
  { state_name: "Maryland", location_name: "Maryland,United States", state_code: "MD" },
  { state_name: "Massachusetts", location_name: "Massachusetts,United States", state_code: "MA" },
  { state_name: "Michigan", location_name: "Michigan,United States", state_code: "MI" },
  { state_name: "Minnesota", location_name: "Minnesota,United States", state_code: "MN" },
  { state_name: "Mississippi", location_name: "Mississippi,United States", state_code: "MS" },
  { state_name: "Missouri", location_name: "Missouri,United States", state_code: "MO" },
  { state_name: "Montana", location_name: "Montana,United States", state_code: "MT" },
  { state_name: "Nebraska", location_name: "Nebraska,United States", state_code: "NE" },
  { state_name: "Nevada", location_name: "Nevada,United States", state_code: "NV" },
  { state_name: "New Hampshire", location_name: "New Hampshire,United States", state_code: "NH" },
  { state_name: "New Jersey", location_name: "New Jersey,United States", state_code: "NJ" },
  { state_name: "New Mexico", location_name: "New Mexico,United States", state_code: "NM" },
  { state_name: "New York", location_name: "New York,United States", state_code: "NY" },
  { state_name: "North Carolina", location_name: "North Carolina,United States", state_code: "NC" },
  { state_name: "North Dakota", location_name: "North Dakota,United States", state_code: "ND" },
  { state_name: "Ohio", location_name: "Ohio,United States", state_code: "OH" },
  { state_name: "Oklahoma", location_name: "Oklahoma,United States", state_code: "OK" },
  { state_name: "Oregon", location_name: "Oregon,United States", state_code: "OR" },
  { state_name: "Pennsylvania", location_name: "Pennsylvania,United States", state_code: "PA" },
  { state_name: "Rhode Island", location_name: "Rhode Island,United States", state_code: "RI" },
  { state_name: "South Carolina", location_name: "South Carolina,United States", state_code: "SC" },
  { state_name: "South Dakota", location_name: "South Dakota,United States", state_code: "SD" },
  { state_name: "Tennessee", location_name: "Tennessee,United States", state_code: "TN" },
  { state_name: "Texas", location_name: "Texas,United States", state_code: "TX" },
  { state_name: "Utah", location_name: "Utah,United States", state_code: "UT" },
  { state_name: "Vermont", location_name: "Vermont,United States", state_code: "VT" },
  { state_name: "Virginia", location_name: "Virginia,United States", state_code: "VA" },
  { state_name: "Washington", location_name: "Washington,United States", state_code: "WA" },
  { state_name: "West Virginia", location_name: "West Virginia,United States", state_code: "WV" },
  { state_name: "Wisconsin", location_name: "Wisconsin,United States", state_code: "WI" },
  { state_name: "Wyoming", location_name: "Wyoming,United States", state_code: "WY" },
];

export const languages = [
  {
    languageName: "English",
    languageCode: "en",
  },
  {
    languageName: "Spanish",
    languageCode: "es",
  },
  {
    languageName: "Portuguese",
    languageCode: "pt",
  },
  {
    languageName: "Polish",
    languageCode: "pl",
  },
  {
    languageName: "German",
    languageCode: "de",
  },
  {
    languageName: "French",
    languageCode: "fr",
  },
  {
    languageName: "Dutch",
    languageCode: "nl",
  },
  {
    languageName: "Italian",
    languageCode: "it",
  },
  {
    languageName: "Swedish",
    languageCode: "sv",
  },
  {
    languageName: "Czech",
    languageCode: "cs",
  },
  {
    languageName: "Slovak",
    languageCode: "sk",
  },
  {
    languageName: "Indonesian",
    languageCode: "id",
  },
  {
    languageName: "Arabic",
    languageCode: "ar",
  },
  {
    languageName: "Hebrew",
    languageCode: "he",
  },
  {
    languageName: "Romanian",
    languageCode: "ro",
  },
];

export const getAllData = async ({
  dispatch,
  keyword,
  id,
  locationName,
  languageCode,
  maxHeadings,

}: {
  dispatch: AppDispatch;
  keyword: string;
  id: string;
  locationName: string;
  languageCode: string;
  maxHeadings: number;

}) => {


  try {
    await dispatch(
      getSerpCompetitors({
        keyword,
        id,
        locationName,
        languageCode,
      })
    );
  } catch (error) {
    console.log("error serp competitors ", error)
  }


  await dispatch(
    getCompetitorsAsync({
      id,
    })
  );





  // await dispatch(
  //   getSerpCompetitorsTopics({
  //     id,
  //   })
  // );

  await dispatch(getAllBriefData(id));
  try {
    await dispatch(
      getQuestions({
        keyword,
        briefId: id,
        locationName,
        languageCode,
        site: "quora.com",
      })
    );
  } catch (error) {
    console.log("error questions quara", error)
  }
  try {
    await dispatch(
      getQuestions({
        keyword,
        briefId: id,
        locationName,
        languageCode,
        site: "reddit.com",
      })
    );
  }
  catch (error) {
    console.log("error questions reddit", error)
  }





};



export const getFakeStatus = (timeDiff: number) => {
  if (timeDiff > 140) {
    return null;
  } else if (timeDiff <= 20) {
    return "Analyzing Competition";
  } else if (timeDiff <= 40) {
    return "Extracting Keywords";
  } else if (timeDiff <= 60) {
    return "Filtering Relevant Keywords";
  } else if (timeDiff <= 110) {
    return "Analyzing Questions to Answer";
  }

}


export const getMainKeyword = ({
  competitors,
  keyword,
}: {
  competitors: CompetitorType[];
  keyword: string;
}) => {
  return competitors[0]?.keywords?.items.find(
    (topic) =>
      topic.keyword_data.keyword.toLowerCase() === keyword.toLowerCase()
  )?.keyword_data?.keyword_info?.search_volume;
};
